import { useEffect, useState } from 'react';
import { IModalAttachment } from '../../../../entities/attachment/model/IModalAttachment.interface';
import { IAttachmentResponse } from '../../../../entities/task/model/types/tasks';
import { isAttachmentResponse } from '../../../../entities/task/lib/isAttachmentResponse';

interface UsePreviewDirectionsReturn {
    currentFile: IModalAttachment | IAttachmentResponse | undefined;
    isFirst: boolean;
    isLast: boolean;
    goNext: () => void;
    goPrev: () => void;
    isAttachmentResponse: boolean;
}

interface UsePreviewDirectionsProps {
    attachments: (IModalAttachment | IAttachmentResponse)[];
    fileIdToPreview: string;
}

export const usePreviewDirections = ({
    attachments,
    fileIdToPreview,
}: UsePreviewDirectionsProps): UsePreviewDirectionsReturn => {
    const [currentIndex, setCurrentIndex] = useState<number>(() => {
        return attachments.findIndex((file) => String(file.id) === fileIdToPreview);
    });

    useEffect(() => {
        const newIndex = attachments.findIndex((file) => String(file.id) === fileIdToPreview);
        if (newIndex >= 0) {
            setCurrentIndex(newIndex);
        }
    }, [attachments, fileIdToPreview]);

    const currentFile = attachments[currentIndex] || undefined;
    const isFirst = currentIndex === 0;
    const isLast = currentIndex === attachments.length - 1;

    const goNext = () => {
        if (!isLast) setCurrentIndex((prev) => prev + 1);
    };

    const goPrev = () => {
        if (!isFirst) setCurrentIndex((prev) => prev - 1);
    };

    return {
        currentFile,
        goNext,
        goPrev,
        isFirst,
        isLast,
        isAttachmentResponse: isAttachmentResponse(currentFile),
    };
};
